import type {CSSDimension} from 'platform/foundation';

/** Fixed width for the row-number column (four digits). */
export const IMPORT_VEHICLE_NR_COLUMN_WIDTH: CSSDimension = 'calc(4 * 1ch)';
